import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '@dia/i18n';
import { Button, Screen } from '@dia/ui';
import { useAuth } from '../auth';
import { HeaderActions } from './lib/ui';

/**
 * PIN plus the device token the phone already holds. Four to six digits, a
 * numeric keypad, and big targets: this is used with wet hands.
 */
export function SignIn() {
  const { t, lang } = useT();
  const { signIn, loading, error, paired, attemptsLeft } = useAuth();
  const [pin, setPin] = useState('');

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    await signIn(pin);
    setPin('');
  };

  const links = (
    <div className="mt-8 flex flex-col gap-2">
      <Link to="/registrar" className="inline-flex min-h-tap items-center text-accent underline underline-offset-4">
        {t('ops.login.have_link')}
      </Link>
      <Link to="/dueno" className="inline-flex min-h-tap items-center text-accent underline underline-offset-4">
        {t('ops.login.owner_link')}
      </Link>
    </div>
  );

  if (!paired) {
    return (
      <Screen title={t('ops.login.title')} actions={<HeaderActions badge={false} />}>
        <p className="text-inkMuted">{t('ops.login.not_paired')}</p>
        {links}
      </Screen>
    );
  }

  return (
    <Screen title={t('ops.login.title')} actions={<HeaderActions badge={false} />}>
      <form onSubmit={onSubmit} className="mt-4 flex flex-col gap-6">
        <label className="flex flex-col gap-2">
          <span>{t('ops.login.pin_label')}</span>
          <input
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 6))}
            inputMode="numeric"
            autoComplete="one-time-code"
            type="password"
            required
            className="min-h-tap rounded border border-line bg-surface px-4 text-center text-[1.6em] tracking-[0.4em] text-ink"
          />
        </label>

        {error && (
          <p role="alert" className="text-danger">
            {lang === 'es' ? error.es : error.en}
            {attemptsLeft !== null && ` (${attemptsLeft})`}
          </p>
        )}

        <Button type="submit" block size="lg" busy={loading} busyLabel={t('loading')}>
          {t('ops.login.submit')}
        </Button>
      </form>
      {links}
    </Screen>
  );
}
